import React, { useState } from "react";
import "../styles/donationCheckout.css"
import { base_url } from "../utils/baseUrl";
 import { FaLock } from "react-icons/fa";

const DonatePage = () => {
  const [amount, setAmount] = useState(2000);
  const [customAmount, setCustomAmount] = useState("");
  const [useCustomAmount, setUseCustomAmount] = useState(false);
   const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  
  });

  const donationOptions = [2000, 5000, 20000, 50000, 100000];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const selectedAmount = useCustomAmount
    ? Number(customAmount)
    : amount;

const donationProcess = async () => {
  if (!selectedAmount || selectedAmount <= 0) {
    alert("Please enter a valid donation amount");
    return;
  }

  // ✅ generate stable merchant reference
  const merchantReference = `DON-${Date.now()}`;

  try {
    const payload = {
      // 🔔 IMPORTANT: backend callback, not frontend
      callbackUrl: "http://localhost:3000/response",

      updatePesapalIPNID: "248d40ad-720e-42a6-a697-dcaf6664af82",

      amount: 1,

      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      phone: formData.phone,

      paymentType: "Donation",

      // ✅ pass merchantReference explicitly
      merchantReference,
    };

    const response = await fetch(
      `${base_url}pesapal/process-donation`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }
    );

    const data = await response.json();

    if (data?.data?.redirect_url) {
      // ✅ redirect to Pesapal
      window.location.href = data.data.redirect_url;
    } else {
      alert(data.message || "Donation failed");
    }
  } catch (error) {
    console.error(error);
    alert("Something went wrong. Please try again.");
  }
};


  return (
    <section className="donate-checkout section">
      <div className="container">

        {/* ================= DONATION AMOUNT ================= */}
        <h3>Select Donation Amount</h3>

        <div className="donation-options">
          {donationOptions.map((value) => (
            <button
              key={value}
              type="button"
              className={`amount-btn ${
                amount === value && !useCustomAmount ? "active" : ""
              }`}
              onClick={() => {
                setAmount(value);
                setUseCustomAmount(false);
              }}
            >
              KES {value.toLocaleString()}
            </button>
          ))}

          <button
            type="button"
            className={`amount-btn ${useCustomAmount ? "active" : ""}`}
            onClick={() => setUseCustomAmount(true)}
          >
            Other
          </button>
        </div>

        {useCustomAmount && (
          <input
            type="number"
            placeholder="Enter amount (KES)"
            value={customAmount}
            onChange={(e) => setCustomAmount(e.target.value)}
            className="custom-amount-input"
          />
        )}

        {/* ================= PERSONAL DETAILS ================= */}
         <h3 className="mt-5">Personal Details</h3>

        <div className="personal-details-grid">
          <div className="form-group">
            <label>First Name</label>
            <input
              type="text"
              name="firstName"
              placeholder="Enter your first name"
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Last Name</label>
            <input
              type="text"
              name="lastName"
              placeholder="Enter your last name"
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              name="email"
              placeholder="you@example.com"
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Phone Number</label>
            <input
              type="tel"
              name="phone"
              placeholder="07XXXXXXXX"
              onChange={handleChange}
            />
          </div>
        </div>

          

        {/* ================= SECURITY NOTE ================= */}
        <p className="secure-note">
          <FaLock className="lock-icon"/> Your data is safe and securely processed.
        </p>

        {/* ================= SUBMIT ================= */}
        <button className="donation-btn mt-4"  >
          Proceed to Secure Payment
        </button>
      </div>
    </section>
  );
};

export default DonatePage;